import axiosInstance from "../helpers/axiosInstance";

/**
 * Submit corrected address to Estafeta
 * @param {Object} data - Request body with order_id and corrected_address
 * @returns {Promise}
 */
export const updateEstafetaAddress = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/carriers/estafeta/address-corrections`,
    data
  );
  return response.data;
};

/**
 * Fetch order by shipping number (if needed)
 * @param {string} shippingNumber - Estafeta shipping/tracking number
 * @returns {Promise}
 */
export const fetchOrderByShippingNumber = async (shippingNumber) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/orders/by-shipping-number/${shippingNumber}`
  );
  return response.data;
};
